import React, { useState } from "react";
import { FormProvider } from "./FormContext";
import PartnerFormStep1 from "./partnerFormStep1";
import PartnerFormStep2 from "./partnerFormStep2";
import IMAGES from "@/public/assets/img";
import Image from "next/image";

const PartnerFormMexico = ({ formType = "ExportForm" }) => {
  const [showNextStep, setShowNextStep] = useState(false);
  const [isFirstStepCompleted, setIsFirstStepCompleted] = useState(false);

  const showFirstStep = () => setShowNextStep(false);

  const handleFirstStepCompletion = () => {
    setIsFirstStepCompleted(true);
    setShowNextStep(true);
  };

  return (
    <div className="sm:px-2 my-5">
      <div className="bg-white sm:mt-2 shadow-icon-btn-shadow rounded-lg py-3 px-3 sm:px-2 lg:w-full lg:max-w-[500px] md:max-w-[510px] sm:w-[100%] ml-auto md:relative md:m-auto border-#FFFFFF">
        {/* ✅ Back Button (shows only on Step 2) */}
        {showNextStep && (
          <div
            className="flex items-center cursor-pointer text-[#022B5C]"
            onClick={showFirstStep}
          >
            <span className="mr-1">
              <svg
                xmlns="https://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="rgba(0,0,0,1)"
              >
                <path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"></path>
              </svg>
            </span>
            <h3 className="text-lg sm:text-base text-brand md:text-base">
            Únase a Nuestra Red
            </h3>
          </div>
        )}

        {/* Title (Hidden when Step 2 back button is shown) */}
        {!showNextStep && (
          <Image
            src={IMAGES?.partnerProgram?.tenxFasterES}
            width={325}
            height={50}
            alt="Tenx Faster"
          />
        )}

        <FormProvider>
          {!showNextStep ? (
            <PartnerFormStep1 showStep1={handleFirstStepCompletion} />
          ) : (
            <PartnerFormStep2
              showPrevStep={showFirstStep}
              formType={formType}
            />
          )}
        </FormProvider>
      </div>
    </div>
  );
};

export default PartnerFormMexico;
